/* eslint-disable */
import {
  Checkbox,
  Flex,
  Popover,
  Radio,
  Space,
  Button,
  Dropdown,
  Modal,
  Spin,
  message,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import {
  CaretDownOutlined,
  OneToOneOutlined,
  SyncOutlined,
  MenuOutlined,
  EditOutlined,
  PlusOutlined 
} from "@ant-design/icons";
import api from "@/utils/api";
import http from "@/utils/http";
import moment from "moment";
import { CustomTable } from "@/hocComponents";
import commonFn from "@/utils/commonFn";
import AddModal from "./component/addModal";
import ResetModal from "./component/editModal";
import "./component/index.scss";

export default function BankIndex() {
  const addModalRef = useRef(null);
  const EditModalRef = useRef(null);
  const [pdfVisible, setPdfVisible] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [pdfLoading, setPdfLoading] = useState(false);


  const openPDFModal = async (fileObj) => {
    setPdfVisible(true);
    setPdfLoading(true);

    try {
      const payload = [fileObj];

      const res = await http.post(api.getVendorPDF, payload, {
        responseType: "blob",
      });

      // 创建浏览器本地 PDF URL
      const blob = new Blob([res], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      setPdfUrl(url);
    } catch (err) {
      console.error("加载 PDF 失败：", err);
      message.error("Unable to load PDF file");
    }

    setPdfLoading(false);
  };

  // 默认选中的值
  const [selectedItems, setSelectedItems] = useState([]);
  const [options, setOptions] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [columns, setColumns] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [statementTypeOptions, setStatementTypeOptions] = useState([]);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });

  // checkbox change
  const handleChange = (checkedValues) => {
    setSelectedItems(checkedValues);
    setColumns(
      initColumns.map((item) => ({
        ...item,
        hidden: !checkedValues.includes(item.dataIndex),
      }))
    );
  };

  const showModal = () => {
    addModalRef.current?.setModelAdd();
  };

  const content = (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <Checkbox.Group
        options={options}
        value={selectedItems}
        className="checkBox"
        onChange={handleChange}
      >
        <Space direction="vertical">
          {options.map((option) => (
            <Checkbox key={option.value} value={option.value}>
              {option.label}
            </Checkbox>
          ))}
        </Space>
      </Checkbox.Group>
    </div>
  );

  const handleMenuClick = async (e, record) => {
    if (e.key === "edit") {
      EditModalRef.current?.open(record);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (keys) => setSelectedRowKeys(keys),
  };

  /** ---------------------- Table filters ---------------------- */
  const initTableHead = {
    role: null,
    module: null,
    firstName: null,
    dateTimeRequest: null,
  };
  const [tableHead, setTableHead] = useState(initTableHead);

  const tableFilterFn = (event, key, type = "Input") => {
    commonFn.tableFilterFn({ event, key, type, setTableHead, getTableListFn });
  };

  /** ---------------------- Table Columns ---------------------- */
  const initColumns = [
    // {
    //   title: "#",
    //   key: "#",
    //   dataIndex: "#",
    //   hidden: false,
    //   align: "center",
    //   width: 80,
    // },
    {
      title: "Action",
      key: "action",
      dataIndex: "bankId",
      hidden: false,
      align: "center",
      width: 60,
      render: (text, record) => (
        <Dropdown
          menu={{
            items: [
              {
                key: "edit",
                icon: (
                  <EditOutlined style={{ color: "#00c0ef", fontSize: 17 }} />
                ),
                label: <div>Edit Owner Information</div>,
              },
            ],
            onClick: (e) => handleMenuClick(e, record),
          }}
          trigger={["click"]}
        >
          <MenuOutlined
            style={{ cursor: "pointer", fontSize: 16, color: "#0e78a9" }}
          />
        </Dropdown>
      ),
    },

    {
      title: "Group",
      dataIndex: "groupCode",
      titleType: "Input",
      width:120,
      onChange: (e) => tableFilterFn(e, "groupCode"),
    },
    {
      title: "Group Name",
      dataIndex: "groupName",
      titleType: "Input",
      width:180,
      onChange: (e) => tableFilterFn(e, "groupName"),
    },
    {
      title: "Supervisor",
      dataIndex: "supervisor",
      titleType: "Select",
      selectOptions: statementTypeOptions,
      width:160,
      onChange: (e) => tableFilterFn(e, "supervisor", "select"),
    },

    {
      title: "Phone",
      dataIndex: "phone",
      titleType: "Input",
      width: 130,
      onChange: (e) => tableFilterFn(e, "phone"),
    },
    {
      title: "Street",
      dataIndex: "street",
      titleType: "Input",
      width:220,
      onChange: (e) => tableFilterFn(e, "street"),
    },
    {
      title: "City",
      dataIndex: "city",
      titleType: "Input",
      width: 120,
      onChange: (e) => tableFilterFn(e, "city"),
    },
    {
      title: "State",
      dataIndex: "state",
      titleType: "Input",
      width: 100,
      onChange: (e) => tableFilterFn(e, "state"),
    },

    {
      title: "Zip",
      dataIndex: "zip",
      titleType: "Input",
      width:100,
      onChange: (e) => tableFilterFn(e, "zip"),
    },
    {
      title: "County",
      dataIndex: "county",
      titleType: "Input",
      width:140,
      onChange: (e) => tableFilterFn(e, "county"),
    },
       {
      title: "File",
      dataIndex: "groupFile",
      width:90,
      render: (file) =>
        file ? (
          <a
            style={{ color: "#1677ff", cursor: "pointer" }}
            onClick={() => openPDFModal(file)}
          >
            File
          </a>
        ) : (
          " "
        ),
    },
    {
      title: "Tenant Statement",
      dataIndex: "tenantStatementFile",
      width:150,
      render: (file) =>
        file ? (
          <a
            style={{ color: "#1677ff", cursor: "pointer" }}
            onClick={() => openPDFModal(file)}
          >
            Tenant Statement
          </a>
        ) : (
          " "
        ),
    },

    {
      title: "Date & Time",
      dataIndex: "closeDate",
      width:150,
      render: (text) => text && moment(text).format("MM/DD/YYYY"),
    },
    {
      title: "Sup. Office",
      dataIndex: "office",
      titleType: "Input",
      width:140,
      onChange: (e) => tableFilterFn(e, "office"),
    },
    {
      title: "Office Hours",
      dataIndex: "officeHour",
      titleType: "Input",
      width:150,
      onChange: (e) => tableFilterFn(e, "officeHour"),
    },
  ];

  /** ---------------------- 获取表格数据 ---------------------- */
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);
    const params = {
      page: current || pagination.current,
      count: pageSize || pagination.pageSize,
      ...tableHead,
    };
    const response = await http.get(api.getGropTableList, { params });
    if (response?.code !== "1") {
      commonFn.modalFailedFn(response);
      setTableLoading(false);
      return;
    }
    const list = (response.data.list || []).map((item, index) => ({
      ...item,
      "#": (params.page - 1) * params.count + index + 1,
      key: item.ownerId,
    }));
    setTableList(list);
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }));
    setTableLoading(false);
  };

  const handleTableChange = (pagination) => {
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  };

  const initColunmsFn = () => {
    setTableHead(initTableHead);
    setColumns(initColumns);
    const transformedList = initColumns.map((item) => ({
      label: item.title,
      value: item.dataIndex,
    }));
    setOptions(transformedList);
    const transformedList2 = initColumns.map((item) => item.dataIndex);
    setSelectedItems(transformedList2);
  };

  const getSupervisorList = async () => {
    try {
      const response = await http.get(api.getGroupBySupervisor);

      if (response.code === "1") {
        const formattedRole = response.data.map((item) => ({
          label: item.supervisor,
          value: item.supervisor,
        }));

        setStatementTypeOptions(formattedRole);
      }
    } catch (error) {
      message.error("Error fetching Supervisor List");
    }
  };

  useEffect(() => {
    initColunmsFn();
    getTableListFn(1, 25);
    getSupervisorList();
  }, [refreshKey]);

  return (
    <div>
      <Flex className="topDiv" justify="space-between" align="flex-start">
        <div>
          <Button className="btnNew" onClick={showModal}>
             <PlusOutlined />
            New
          </Button>
        </div>
        <div className="min-width">
          <Radio.Group defaultValue="a" size="middle">
            <Radio.Button value="a" onClick={() => setRefreshKey(+new Date())}>
              <SyncOutlined />
            </Radio.Button>
            <Radio.Button value="b">
              <Popover content={content} title="" trigger="click">
                <OneToOneOutlined />
                <CaretDownOutlined className="ft12" />
              </Popover>
            </Radio.Button>
          </Radio.Group>
        </div>
      </Flex>

      {/* ---------------------- 表格 ---------------------- */}
      <CustomTable
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
        tableScrollY="350px"
        tableCss="maintenanceTable"
        rowKey="groupId"
        rowSelection={rowSelection}
      />

      {/* 新增/Add Modal */}
      <AddModal
        ref={addModalRef}
        onSuccess={() => {
          getTableListFn(pagination.current, pagination.pageSize, tableHead);
        }}
      />

      {/* 编辑 Modal */}
      <ResetModal
        ref={EditModalRef}
        onSuccess={() => {
          getTableListFn(pagination.current, pagination.pageSize, tableHead);
        }}
      />

      {/* ----------------------  PDF 预览 Modal ---------------------- */}
      <Modal
       
          title={
        <div style={{ fontSize: "24px", fontWeight: "bold" }}>
         Tenant Statement PDF
          <div
            style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
          ></div>
        </div>
      }
        open={pdfVisible}
        onCancel={() => setPdfVisible(false)}
        footer={null}
        width='60%'
      >
        {pdfLoading ? (
          <Spin />
        ) : pdfUrl ? (
          <iframe
            src={pdfUrl}
            width="100%"
            height="650px"
            style={{ border: "none" }}
          />
        ) : (
          <p>No PDF available</p>
        )}
      </Modal>
    </div>
  );
}
